var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#1B49EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.3359H14.5556H27",
    stroke: "#1B49EA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8883 15.3338V13.7782C16.8883 13.3657 17.0522 12.97 17.3439 12.6783C17.6356 12.3865 18.0313 12.2227 18.4438 12.2227H21.5549C21.9675 12.2227 22.3632 12.3865 22.6549 12.6783C22.9466 12.97 23.1105 13.3657 23.1105 13.7782V15.3338M25.4438 15.3338V26.2227C25.4438 26.6352 25.2799 27.0309 24.9882 27.3226C24.6965 27.6143 24.3008 27.7782 23.8883 27.7782H16.1105C15.6979 27.7782 15.3023 27.6143 15.0105 27.3226C14.7188 27.0309 14.5549 26.6352 14.5549 26.2227V15.3338H25.4438Z",
    stroke: "#1B49EA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleted);
export default __webpack_public_path__ + "static/media/deleted.fa6d61d9246f7dfcf81236627c5ba3d1.svg";
export { ForwardRef as ReactComponent };